import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InlineSVGModule } from 'ng-inline-svg';
import { RenewalsIndexComponent } from './pages/renewals-index/renewals-index.component';
import { RenewalsJourneyComponent } from './pages/renewals-journey/renewals-journey.component';
import { RenewalsMatrixCustomerDetailsComponent } from '../matrix/pages/renewals-matrix-customer-details/renewals-matrix-customer-details.component';

const routes: Routes = [
  { path: '', component: RenewalsIndexComponent },
  { path: 'select-journey/:quoteRequestId', component: RenewalsJourneyComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    InlineSVGModule
  ],
  exports: [RouterModule]
})
export class RenewalsSharedRoutingModule { }
